/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

/**
 * ExpressEditState Input Action
 */
export class ExpressEditStateInput implements Msdyn365.IActionInput {
    // ExpressEditStateInput: Construct the input needed to run the action
    constructor() {}

    // ExpressEditState: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `ExpressEditState`;
    public getCacheObjectType = () => 'ExpressEditState';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

// IExpressEditStateData: Create a data model here or import one to capture the response of the action
export interface IExpressEditStateData {
    shippingEdit: boolean;
    deliveryEdit: boolean;
}

/**
 * createInput: Use this function to create the input required to make the action call
 */
const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new ExpressEditStateInput();
};

/**
 * action: Use this function to call your action and process the results as needed
 */
async function action(input: ExpressEditStateInput, ctx: Msdyn365.IActionContext): Promise<IExpressEditStateData> {
    // const apiSettings = Msdyn365.msdyn365Commerce.apiSettings;

    // const response = await Msdyn365.sendRequest<IExpressEditStateData[]>('/get/example/id/1', 'get');
    return { shippingEdit: false, deliveryEdit: false };
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IExpressEditStateData>>action,
    // id: Give your data action a unique id
    id: 'ExpressEditState',
    input: createInput
    // isBatched: true
});
